import * as t from './actionTypes'
import { State, AccountSlice } from './model'

const initialState: State = { byAccount: {} }

const emptySlice: AccountSlice = {
  template: [],
  templateVersion: null,
  files: [],
  legacy: [],
  archived: [],
  selectedPath: null,
  uploading: false,
}

const getSlice = (state: State, number: string): AccountSlice =>
  state.byAccount[number] || emptySlice

const setSlice = (state: State, number: string, slice: AccountSlice): State => ({
  ...state,
  byAccount: { ...state.byAccount, [number]: slice },
})

export default (state: State = initialState, action: any): State => {
  switch (action.type) {
    case t.SET: {
      const { number, template, template_version, files, legacy, archived } =
        action
      const prev = state.byAccount[action.number]
      return setSlice(state, number, {
        ...emptySlice,
        ...(prev || {}),
        template: template || [],
        templateVersion: template_version || null,
        files: files || [],
        legacy: legacy || [],
        archived: archived || [],
      })
    }
    case t.CLEAR: {
      const next = { ...state.byAccount }
      delete next[action.number]
      return { ...state, byAccount: next }
    }
    case t.SET_UPLOADING: {
      const slice = getSlice(state, action.number)
      return setSlice(state, action.number, {
        ...slice,
        uploading: action.uploading,
      })
    }
    case t.ADD_FILE: {
      const slice = getSlice(state, action.number)
      return setSlice(state, action.number, {
        ...slice,
        files: [...slice.files, action.file],
      })
    }
    case t.ARCHIVE_FILE: {
      const slice = getSlice(state, action.number)
      return setSlice(state, action.number, {
        ...slice,
        files: slice.files.filter((f) => f.id !== action.file.id),
        legacy: slice.legacy.filter((f) => f.id !== action.file.id),
        archived: [...slice.archived, action.file],
      })
    }
    case t.RESTORE_FILE: {
      const slice = getSlice(state, action.number)
      return setSlice(state, action.number, {
        ...slice,
        archived: slice.archived.filter((f) => f.id !== action.file.id),
        files: [...slice.files, action.file],
      })
    }
    case t.MOVE_FILE: {
      const slice = getSlice(state, action.number)
      const inFiles = slice.files.some((f) => f.id === action.file.id)
      if (inFiles) {
        return setSlice(state, action.number, {
          ...slice,
          files: slice.files.map((f) =>
            f.id === action.file.id ? action.file : f,
          ),
        })
      }
      const inLegacy = slice.legacy.some((f) => f.id === action.file.id)
      if (inLegacy) {
        return setSlice(state, action.number, {
          ...slice,
          legacy: slice.legacy.filter((f) => f.id !== action.file.id),
          files: [...slice.files, action.file],
        })
      }
      return state
    }
    case t.RENAME_FILE: {
      const slice = getSlice(state, action.number)
      const replace = (arr) =>
        arr.map((f) => (f.id === action.file.id ? action.file : f))
      return setSlice(state, action.number, {
        ...slice,
        files: replace(slice.files),
        legacy: replace(slice.legacy),
        archived: replace(slice.archived),
      })
    }
    case t.SELECT_PATH: {
      const slice = getSlice(state, action.number)
      return setSlice(state, action.number, {
        ...slice,
        selectedPath: action.path,
      })
    }
    default:
      return state
  }
}
